<template>
  <div class="ly-detail-footer" v-show="enableArea">
    <!-- 버튼티켓: {{ ticktId }} -->
    <div v-if="!$isMobile()">
      <!-- 인시던트 발생 -->
      <el-button
        plain
        type="primary"
        v-show="enableBtnIncidtOcc"
        @click="handelClickIncidtOcc"
        :size="sizeSet"
        >{{ $t("messages.btnIncidentPublish") }}</el-button
      >
    </div>
    <div :class="$isMobile()?'mob-btn':''">
      <el-button
        plain
        type="primary"
        v-show="enableBtnIncidtOcc"
        @click="handelClickIncidtOcc"
        :size="sizeSet"
        v-if="$isMobile()"
        >{{ $t("messages.btnIncidentPublish") }}</el-button
      >
      <!-- 담당자이관 -->
      <el-button
        plain
        type="primary"
        v-show="enableBtnTkcgrTrc"
        @click="handleClickTkcgrTrc"
        :size="sizeSet"
        >{{ $t("messages.btnTkcgrTrc") }}</el-button
      >
      <!-- 수령 -->
      <el-button
        plain
        type="primary"
        v-show="enableBtnRecp"
        @click="handleClickRecp"
        :size="sizeSet"
        >{{ $t("messages.btnReceipt") }}</el-button
      >
      <!-- 보류 -->
      <el-button
        plain
        type="primary"
        v-show="enableBtnHld"
        @click="handleClickHld"
        :size="sizeSet"
        >{{ $t("messages.btnHold") }}</el-button
      >
      <!-- 보류취소 -->
      <el-button
        plain
        type="primary"
        v-show="enableBtnHldCncl"
        @click="handleClickHldCncl"
        :size="sizeSet"
        >{{ $t("messages.btnHoldCancel") }}</el-button
      >
      <!-- 반려 -->
      <el-button
        type="save"
        v-show="enableBtnRcess"
        @click="handleClickRcess"
        :size="sizeSet"
        >{{ $t("messages.btnReject") }}</el-button
      >
      <!-- 공정완료 -->
      <el-button
        type="primary"
        v-show="enableBtnCmplt"
        @click="handleClickCmplt"
        :size="sizeSet"
        >{{ $t("messages.btnPrcssComplete") }}</el-button
      >
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    location: {
      type: String,
      default: '',
    },
    enableArea: {
      type: Boolean,
      default: true,
    },
    exeWflowId: {
      type: String,
      default: '',
    },
    ticktId: {
      type: String,
      default: '',
    },
    activeButtonList: {
      type: Array,
      default: () => []
    },
    allTicketList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      crrTicket: {},
      isAuth: false
    };
  },
  watch: {
    allTicketList() {
      this.changeTicket();
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.changeTicket();
    });
  },
  computed: {
    changeAuth() {
      return this.isAuth;
    },
    sizeSet(){
        return this.$isMobile() ? 'small':'medium';
    },
    /*
    2898	2828	공정완료
    2900	2828	반려
    2901	2828	보류
    3127	2828	인시턴트 발생
    3128	2828	담당자이관
    */
    enableBtnIncidtOcc() {
      if (this.enableBtn("3127")) { // 3127 인시던트 버튼 코드
        // 진행(2873) 상태에서만 가능
        if (this.changeAuth && this.crrTicket.ticktSttusCd == 2873) {
          return true;
        }
      }
      return false;
    },
    enableBtnTkcgrTrc() {
      if (this.enableBtn("3128")) { // 3128 담당자이관 버튼 코드
        // 진행(2873) 상태에서만 가능
        if (this.changeAuth && this.crrTicket.ticktSttusCd == 2873) {
          return true;
        }
      }
      return false;
    },
    enableBtnRecp() {
      // 설정에서 수령버튼 삭제 처리 상태로 표기
      //if (this.enableBtn("2902")) { // 2902 수령 코드
        // 대기(2871) 상태에서만 가능
        if (this.changeAuth && this.crrTicket.ticktSttusCd == 2871) {
          return true;
        }
      //}
      return false;
    },
    enableBtnHld() {
      if (this.enableBtn("2901")) { // 2901 보류 코드
        // 진행(2873) 상태에서만 가능
        if (this.changeAuth && this.crrTicket.ticktSttusCd == 2873) {
          return true;
        }
      }
      return false;
    },
    enableBtnHldCncl() {
      // 보류(2875) 상태에서만 가능
      if (this.changeAuth && this.crrTicket.ticktSttusCd == 2875) {
        return true;
      }
      return false;
    },
    enableBtnRcess() {
      if (this.enableBtn("2900")) { // 2900 반려 코드
        // 진행(2873) 상태에서만 가능
        if (this.changeAuth && this.crrTicket.ticktSttusCd == 2873) {
          return true;
        }
      }
      return false;
    },
    enableBtnCmplt() {
      if (this.enableBtn("2898")) { // 2898 공정완료
        // 진행(2873) 상태에서만 가능
        if (this.changeAuth && this.crrTicket.ticktSttusCd == 2873) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    changeTicket() {
      //console.log('티켓 아이디: ' + this.ticktId)
      const ticketList = this.allTicketList; // this.$store.getters["wflowStore/getExeWflowTicketList"];
      //console.log(ticketList)
      for (var tmpTicket of ticketList) {
        if (tmpTicket.ticktId == this.ticktId && tmpTicket.wrkCtgCd != 0) {
          this.crrTicket = Object.assign({}, tmpTicket);
          break;
        }
      }
      this.isAuth = this.crrTicket.isWrite; // this.chkBtnAuth();

      // 단계 티켓이 있는 경우 단계 티켓이 진행(2873) 중인 경우 가능
      if ( Object.keys(this.crrTicket).length == 0 ) { return; }
      const stepCd = this.crrTicket.stepCd;
      for (var tmpTicket of ticketList) {
        if (tmpTicket.stepCd == stepCd && tmpTicket.wrkCtgCd == 0) {
          if (tmpTicket.ticktSttusCd != 2873) {
            this.isAuth = false;
            break;
          }
        }
      }
    },
    async chkBtnAuth() {
      const ticketInfo = this.crrTicket;
      console.log('공정버튼티켓')
      console.log(ticketInfo)

      var isAuth = ticketInfo.isWrite;
      /*
      var isAuth = false;
      if (ticketInfo.asgnrId != null) {
        if (ticketInfo.asgnrId == userInfo.userId) { // 진행: 2873
          isAuth = true;
        }
      }
      else {
        if (ticketInfo.asgnWrkGroupId != null) {
          isAuth = await this.includeRule(ticketInfo.asgnWrkGroupId, userInfo.userId);
        }
      }
      */

      return isAuth;
    },

    async includeRule(roleId, usrId) {
      if (roleId == null || roleId == '' || usrId == null || usrId == '') return false;

      const resultData = await this.$BIZ_SERVICE.post(this.$API_URLS.Com.getUserInfoListByRoleId, {
          roleId: roleId,
          userId: usrId,
        });
      if (resultData.status == 200 && resultData.data.resData.length > 0) {
        return true;
      }

      return false;
    },

    enableBtn(btnCd) {
      return this.activeButtonList.reduce((cnt, element) => cnt + (btnCd === element), 0) == 0 ? false : true;
    },
    handelClickIncidtOcc() {
      // 인시던트등록 레이어 팝업 활성
      this.$EventBus.$emit("clickBtnIncidentRegist", {});
    },
    handleClickTkcgrTrc() {
      this.$EventBus.$emit("clickBtnTkcgrTrc", {
        ticktId: this.crrTicket.ticktId
      });
    },
    handleClickRecp() {
      // 수령
      this.$store.dispatch("wflowStore/postRepeipt", {
        ticktId: this.crrTicket.ticktId
      }).then(res => {
        this.$EventBus.$emit("tabReload");
      });
    },
    handleClickHld() {
      // 보류
      this.$store.dispatch("wflowStore/postHld", {
        ticktId: this.crrTicket.ticktId,
        txtTitle: this.$t("messages.holdCancel")
      }).then(res => {
        this.$EventBus.$emit("tabReload");
      });
    },
    handleClickHldCncl() {
      // 보류취소 - 수령과 동일
      this.$store.dispatch("wflowStore/postRepeipt", {
        ticktId: this.crrTicket.ticktId

      }).then(res => {
        this.$EventBus.$emit("tabReload");
      });
    },
    handleClickRcess() {
      // 반려
      this.$store.dispatch("wflowStore/postPrcssRcess", {
        exeWflowId: this.exeWflowId,
        ticktId: this.crrTicket.ticktId
      }).then(res => {
        this.$EventBus.$emit("tabReload");
      });
    },
    handleClickCmplt() {
      if (!confirm('현 공정을 완료하시겠습니까?')) return;

      this.$EventBus.$emit("beforeCompleteButton", () => {
        this.$store.dispatch("wflowStore/postPrcssComplete", {
          exeWflowId: this.exeWflowId,
          ticktId: this.crrTicket.ticktId,
        }).then(res => {
          // alert("현 공정를 완료하였습니다.");
          this.$EventBus.$emit("completeButton");
        }).catch(err => {
          alert("공정에 실패하였습니다.");
          console.log(err);
          console.log(err.response);
        });
      }, this.crrTicket);

    },
  },
};
</script>
<style lang="scss" scoped>
@include mobile {
  .ly-detail-footer{
    // display: inline?
    .mob-btn{
      display: flex;
      justify-content: space-between;
      width: 100%;
      .el-button{
        margin: 0;
        padding: 7px 9px;
      }
    }
  }
}
</style>